export default __webpack_public_path__ + "static/media/Clasp of the Haunter in the Dark.a00d5bd6.jpg";